export default __webpack_public_path__ + "static/apple-touch-icon-180x180-7f51bfa2fa964c208084c5029e7eec16.png";